<div
  #ib_credit_stepper
  *ngFor="let stepper of ibCreditFormConfig(); let i = index"
>
  @if (stepper?.divider) {
    <mat-divider class="border-t border-gray-300"></mat-divider>
  }
  <form [formGroup]="ibCreditForm">
    <div class="text-sm md:text-lg font-semibold text-foreground mb-[10px]">
      {{ stepper?.label }}
    </div>
    <div
      class="grid grid-cols-1 md:grid-cols-4 gap-x-[20px] gap-y-[20px] mt-2 mb-8"
    >
      <ng-container *ngFor="let field of stepper?.fields">
        <!-- Text Input -->
        <div
          *ngIf="field.type === inputTypeEnum.TEXT && isFieldEnabled(field)"
          class="md:col-span-2"
          [style]="field.style"
          [style.display]="field?.isHidden ? 'none' : 'block'"
        >
          <div class="relative">
            <mat-form-field
              appearance="outline"
              class="w-full mt-2 pt-3"
              [ngClass]="{ 'form-field-disabled': field?.isDisable }"
            >
              <mat-label class="!text-[14px]">{{
                placeHolder()?.[field?.name]
              }}</mat-label>
              <input
                matInput
                [disabled]="field?.isDisable"
                [readonly]="field?.isDisable"
                [id]="field?.name"
                [formControlName]="field?.name"
                [placeholder]="placeHolder()?.[field?.name]"
                [attr.minlength]="field?.minlength"
                [attr.maxlength]="field?.maxlength"
                [type]="field?.type"
                class="placeholder-truncate w-full rounded-sm !text-[14px] -translate-y-[7px]"
                [ngStyle]="{ borderColor: '#494949' }"
                (input)="checkAndTransformInput($event, field)"
                (click)="
                  handleEvent(
                    $event,
                    field,
                    field.actions?.event?.onClick?.functionName,
                    field.actions?.event?.onClick?.params
                  )
                "
                (blur)="
                  handleEvent(
                    $event,
                    field,
                    field.actions?.event?.onBlur?.functionName,
                    field.actions?.event?.onBlur?.params
                  )
                "
                (keypress)="handleInput($event, field)"
              />
              <mat-hint class="text-[11px] px-1 text-[#6c6c6c]">{{
                field?.hintText
              }}</mat-hint>
              <!-- verify button start -->

              @if (!isInputInvalid(field?.name)) {
                <div
                  *ngIf="field?.actions?.verifyButton?.showVerifyButton"
                  class="icon absolute flex items-center justify-center -top-[11px] bottom-1 right-px"
                >
                  <button
                    [disabled]="showLoader()?.[field?.name]"
                    mat-flat-button
                    color="primary"
                    matSuffix
                    type="button"
                    class="text-[#fff] text-[13px] pt-[7px] pb-[7px] pl-[8px] pr-[8px] font-[600] rounded bg-[#467d91] hover:!bg-[#2f2f2f]"
                    (click)="
                      field?.actions?.verifyButton?.action
                        ?.triggerExtraStandardEvents
                        ? handleEvent(
                            $event,
                            field,
                            field?.actions?.verifyButton?.action
                              ?.triggerExtraStandardEvents,
                            field.actions?.verifyButton?.action?.params
                          )
                        : onActionCall(
                            field?.actions?.verifyButton?.action?.type
                          )
                    "
                  >
                    <svg
                      *ngIf="showLoader()?.[field?.name]"
                      class="animate-spin h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        class="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                      />
                      <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8z"
                      />
                    </svg>
                    <span *ngIf="!showLoader()?.[field?.name]">{{
                      field?.actions?.verifyButton?.text
                    }}</span>
                  </button>
                </div>
              }
              <!-- verify button end -->
              @if (!isInputInvalid(field?.name)) {
                <div
                  *ngIf="field?.isVerified"
                  class="icon absolute flex items-center justify-center -top-[11px] bottom-1 -right-[20px] px-[10px]"
                >
                  <img
                    src="../assets/assets-new/images/check-1.svg"
                    class="w-5 h-5 flex-shrink-0"
                  />
                </div>
              }
              <mat-error
                *ngIf="
                  ibCreditForm.get(field.name).touched &&
                  ibCreditForm.get(field.name).errors
                "
                class="p-2"
              >
                @if (
                  ibCreditForm.get(field?.name)?.errors.customError &&
                  errorMessage()?.[field?.name]?.type === MessageType.ERROR
                ) {
                  <span>{{ errorMessage()?.[field?.name]?.text }}</span>
                } @else if (ibCreditForm.get(field.name).hasError('required')) {
                  <span>{{ field?.validation?.errorMessages?.required }}</span>
                } @else if (
                  ibCreditForm.get(field.name).hasError('minlength') &&
                  field?.validation?.errorMessages?.minlength
                ) {
                  <span>{{ field?.validation?.errorMessages?.minlength }}</span>
                } @else if (ibCreditForm.get(field.name).hasError('pattern')) {
                  <span>{{ field?.validation?.errorMessages?.pattern }}</span>
                }
              </mat-error>
            </mat-form-field>
          </div>

          @if (field?.actions?.leftRightCTA) {
            <div class="flex justify-between mt-4">
              <div
                class="text-[#F94D00] font-semibold text-[12px] cursor-pointer underline mt-1"
                [style.pointer-events]="isDisable()?.leftCTA ? 'none' : 'auto'"
                [style.cursor]="
                  isDisable()?.leftCTA ? 'not-allowed' : 'pointer'
                "
                [style.color]="isDisable()?.leftCTA ? '#bbb' : 'inherit'"
                (click)="
                  isDisable()?.leftCTA
                    ? $event.preventDefault()
                    : onActionCall(
                        field?.actions?.leftRightCTA?.leftCTA?.action?.type
                      )
                "
              >
                {{ field?.actions?.leftRightCTA?.leftCTA?.title }}
              </div>
              <div
                class="underline text-[12px] text-[#F94D00] cursor-pointer font-semibold mt-1"
                [style.pointer-events]="
                  isDisable()?.[field?.name]?.rightCTA ? 'none' : 'auto'
                "
                [style.cursor]="
                  isDisable()?.[field?.name]?.rightCTA
                    ? 'not-allowed'
                    : 'pointer'
                "
                [style.color]="
                  isDisable()?.[field?.name]?.rightCTA ? '#ffa37a' : 'inherit'
                "
                (click)="
                  isDisable()?.[field?.name]?.rightCTA
                    ? $event.preventDefault()
                    : onActionCall(
                        field?.actions?.leftRightCTA?.rightCTA?.action?.type
                      )
                "
              >
                {{ field?.actions?.leftRightCTA?.rightCTA?.title }}
              </div>
            </div>
          }

          <div id="for_action">
            <div
              *ngIf="
                !ibCreditForm.get(field?.name).touched &&
                !ibCreditForm.get(field?.name).errors &&
                field?.actions?.messages?.type === MessageType.SUCCESS
              "
              class="text-[#3BB000] font-semibold text-[12px] text-left mt-1"
            >
              {{ field?.actions?.messages?.text }}
            </div>

            @if (
              !ibCreditForm.get(field?.name).touched &&
              errorMessage()?.[field?.name]?.type === MessageType.ERROR &&
              field?.name === 'otp'
            ) {
              <div class="text-[#c00100] text-[13px] text-left mt-1">
                {{ errorMessage()?.[field?.name]?.text }}
              </div>
            }
          </div>
          <div
            *ngIf="field.isTimer"
            class="text-[12px] text-[red] mb-[7px] mt-[3px] text-left"
          >
            <p *ngIf="getTimerObservable(field) | async as remaining">
              {{ remaining }} {{ getTimerMessage(field.name) }}
            </p>
          </div>
        </div>
      </ng-container>
    </div>
    <!-- stepper button start -->
    <div
      *ngIf="stepper?.button"
      class="flex flex-wrap justify-center md:justify-end gap-[10px]"
    >
      <!-- If there is no verification action at all, fallback to rendering the stepper button -->
      <button
        mat-button
        [disabled]="isSubmitButtonDisabled()"
        (click)="
          stepper?.button?.action?.triggerExtraStandardEvents
            ? handleEvent(
                ib_credit_stepper,
                null,
                stepper?.button?.action?.triggerExtraStandardEvents,
                null
              )
            : onActionCall(stepper?.button?.action?.type, i)
        "
        class="border bg-[#F43F0C] text-[#ffffff] disabled:bg-[#a4a4a4] disabled:text-[#fff] disabled:cursor-not-allowed w-auto flex items-center pt-[14px] pb-[14px] pl-[35px] pr-[35px] font-[500] m-auto text-[15px] rounded-[4px] mt-[5px]"
        style="border-color: #f43f0c !important"
      >
        {{ stepper?.button?.text }}
      </button>
    </div>
  </form>
</div>
